import { t } from './i18n/index.js';
import { S, persist } from './state.js';
import { IC, RT, closeAllSheets, closeSheet, esc, nav, sheet } from './ui.js';

/* Help: a short guided tour of the main areas + answers to common questions. */
const FAQ_N=8;

export function openHelp(){
  const b=sheet(`<div class="sheethead"><h2>${t('help.title')}</h2><button class="iconbtn" data-a="x" aria-label="${esc(t('c.close'))}">${IC.x}</button></div>
  <div class="sheetbody">
    <button class="helptour" data-a="story">
      <span class="ht-ic">${IC.play}</span>
      <span class="grow"><b>${t('story.title')}</b><small>${t('story.hint')}</small></span>
      ${IC.right}
    </button>
    <button class="helptour" data-a="tour">
      <span class="ht-ic">${IC.play}</span>
      <span class="grow"><b>${t('help.tour')}</b><small>${t('help.tourHint')}</small></span>
      ${IC.right}
    </button>
    <h3 class="helpsub">${t('help.faq')}</h3>
    <div class="helpfaq">${Array.from({length:FAQ_N},(_,i)=>`<details><summary>${esc(t('help.q'+(i+1)))}</summary><p>${esc(t('help.a'+(i+1)))}</p></details>`).join('')}</div>
    <div class="helpcontact"><span>${t('help.stuck')}</span><button class="btn small" data-a="contact">${t('pm.contact')}</button></div>
  </div>`,'wide');
  b.querySelector('[data-a=x]').onclick=()=>closeSheet(b);
  b.querySelector('[data-a=contact]').onclick=()=>{closeSheet(b);nav('contact')};
  b.querySelector('[data-a=tour]').onclick=()=>{closeSheet(b);setTimeout(()=>startTour(),260)};
  b.querySelector('[data-a=story]').onclick=()=>{closeSheet(b);setTimeout(()=>import('./story.js').then(m=>m.openStory()),260)};
}

/* ---------- guided tour ---------- */
const STEPS=[
  {sel:'[data-nav="home"]',k:'home'},
  {sel:'[data-nav="calendar"]',k:'calendar'},
  {sel:'[data-nav="students"]',k:'students'},
  {sel:'[data-nav="invoices"]',k:'invoices'},
  {sel:'[data-account]',k:'profile'},
];
const visible=sel=>[...document.querySelectorAll(sel)].find(el=>{const r=el.getBoundingClientRect();return r.width>0&&r.height>0&&getComputedStyle(el).visibility!=='hidden'});

export function startTour(onDone){
  closeAllSheets();
  if(RT.v!=='home')nav('home');
  const steps=STEPS.filter(s=>visible(s.sel));
  if(!steps.length){onDone&&onDone();return}
  let i=0;
  const root=document.createElement('div');root.className='tour';
  root.innerHTML='<div class="tour-spot"></div><div class="tour-card" role="dialog" aria-modal="true" aria-live="polite"></div>';
  document.body.appendChild(root);
  const spot=root.querySelector('.tour-spot'),card=root.querySelector('.tour-card');
  const end=()=>{
    window.removeEventListener('resize',place);document.removeEventListener('keydown',keys);
    root.classList.add('out');setTimeout(()=>root.remove(),250);
    S.settings.dismissed=S.settings.dismissed||{};S.settings.dismissed.tour=true;persist();
    onDone&&onDone();
  };
  function place(){
    const el=visible(steps[i].sel);if(!el){end();return}
    const r=el.getBoundingClientRect(),pad=6;
    Object.assign(spot.style,{left:(r.left-pad)+'px',top:(r.top-pad)+'px',width:(r.width+pad*2)+'px',height:(r.height+pad*2)+'px'});
    const cw=Math.min(320,innerWidth-24),ch=card.offsetHeight||170;
    let x,y;
    if(el.closest('.rail')&&r.right+18+cw<innerWidth){x=r.right+18;y=r.top+r.height/2-ch/2}   // desktop sidebar: card to the right
    else{x=r.left+r.width/2-cw/2;y=r.top>innerHeight/2?r.top-ch-16:r.bottom+16}                // tab bar / top bar: above or below
    x=Math.min(Math.max(12,x),innerWidth-cw-12);y=Math.min(Math.max(12,y),innerHeight-ch-12);
    Object.assign(card.style,{left:x+'px',top:y+'px',width:cw+'px'});
  }
  function draw(){
    const s=steps[i],last=i===steps.length-1;
    card.innerHTML=`<div class="tc-step">${t('tour.step',{n:i+1,m:steps.length})}</div>
      <h3>${t('tour.'+s.k+'.t')}</h3><p>${t('tour.'+s.k+'.b')}</p>
      <div class="tc-foot"><button class="linkbtn tc-skip" data-a="skip">${t('tour.skip')}</button>
      <span class="row" style="gap:6px">${i?`<button class="btn small" data-a="back">${t('tour.back')}</button>`:''}<button class="btn small primary" data-a="next">${last?t('tour.done'):t('tour.next')}</button></span></div>`;
    card.querySelector('[data-a=skip]').onclick=end;
    card.querySelector('[data-a=next]').onclick=()=>{if(last)end();else{i++;draw()}};
    const bk=card.querySelector('[data-a=back]');if(bk)bk.onclick=()=>{i--;draw()};
    place();card.querySelector('[data-a=next]').focus();
  }
  function keys(e){if(e.key==='Escape')end();else if(e.key==='ArrowRight'&&i<steps.length-1){i++;draw()}else if(e.key==='ArrowLeft'&&i>0){i--;draw()}}
  window.addEventListener('resize',place);document.addEventListener('keydown',keys);
  draw();requestAnimationFrame(()=>root.classList.add('on'));
}
